export const GEO_CALCULATION_SERVICE_ADDRESS =
  process.env.REACT_APP_GEO_CALCULATION_SERVICE ?? "http://localhost";
export const SERVICE_ACCOUNT_TOKEN_ADDRESS =
  process.env.REACT_APP_SERVICE_ACCOUNT_SERVICE;
export const REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS =
  process.env.REACT_APP_STICK_SCHEDULER_SERVICE ?? "http://localhost";
